const translation = {
    PageSize: 'ページサイズ',
    PageOrientation: 'ページ方向',
    Format: 'フォーマット',
    DPI: 'DPI（解像度）',
    Title: '地図を出力',
    Close: '閉じる',
    Save: '保存',
    FileName: 'ファイル名',
    Landscape: '横向き',
    Portrait: '縦向き',
    PreviewHint: '地図上で出力範囲を調整します。',
    ExportFailed: '地図の出力に失敗しました。もう一度お試しください。',
    PreviewFailed: 'プレビューを作成できませんでした。',
    AdjustArea: '地図上で範囲を調整',
    AdjustAreaHint: '地図を移動・拡大縮小・回転・傾けて出力範囲を合わせてください',
    ZoomIn: '拡大',
    ZoomOut: '縮小',
    ResetZoom: '100%に戻す',
    Done: '完了',
    Cancel: 'キャンセル',
    Scalebar: 'スケールバー',
    NorthIcon: '方位記号',
    ChooseNorthIcon: '方位記号のアイコンを選択',
    ChooseSvgFile: 'SVGファイルを選択',
    IconSymbol: '記号',
    IconColor: '色',
    IconSize: 'サイズ',
    InvalidSvg: 'SVGファイルとして読み込めませんでした。',
    ExportAsVector: 'ベクターとして出力',
    ExportLabelsAsVector: 'ラベルをベクターとして出力',
    Custom: 'カスタム',
    Width: '幅',
    Height: '高さ',
    LanguageName: '日本語',
    LanguageCode: 'ja'
};
export default translation;
